import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometen-main-banner',
  templateUrl: './hometen-main-banner.component.html',
  styleUrls: ['./hometen-main-banner.component.scss']
})
export class HometenMainBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
